import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Seo, { localBusinessSchema } from "@/components/Seo";
import { CONTACT } from "@/lib/content";
import { ArrowRight, Loader2 } from "lucide-react";

export default function BlogList() {
  const [posts, setPosts] = useState(null);
  useEffect(() => { api.get("/blog").then(({ data }) => setPosts(data)); }, []);

  return (
    <div className="min-h-screen bg-[#0c0c0f] text-white" data-testid="blog-list">
      <Seo
        title="Blog — Auto Protection Insights & News"
        description="Detailing & Tint knowledge base — care guides, product deep-dives, and news from WTD Edmonton."
        path="/blog"
        jsonLd={[localBusinessSchema({ contact: CONTACT })]}
      />
      <Navbar />
      <main className="pt-32 pb-20">
        <div className="max-w-6xl mx-auto px-6 md:px-10">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-8 h-px bg-[#1F5EFF]"/>
            <span className="font-mono-alt text-[12px] text-[#1F5EFF]">Journal</span>
          </div>
          <h1 className="font-display text-5xl md:text-7xl font-light tracking-tighter mb-14">
            Notes from the studio<span className="text-[#1F5EFF] blue-text-glow">.</span>
          </h1>

          {!posts ? (
            <div className="py-20 flex justify-center"><Loader2 className="w-6 h-6 text-white/40 animate-spin"/></div>
          ) : posts.length === 0 ? (
            <div className="py-20 text-center text-white/40 bg-[#121216] border border-dashed border-white/10 rounded-2xl">
              No articles published yet — check back soon.
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {posts.map((p) => (
                <Link key={p.id} to={`/blog/${p.slug}`} data-testid={`post-${p.slug}`}
                  className="group bg-[#121216] border border-white/12 rounded-2xl p-8 hover:border-[#1F5EFF]/40 transition-colors block">
                  <div className="font-mono-alt text-[10px] text-white/40">
                    {new Date(p.published_at || p.created_at).toLocaleDateString("en-CA", {
                      year: "numeric", month: "long", day: "numeric"
                    })}
                  </div>
                  <h2 className="mt-4 font-display text-2xl md:text-3xl text-white group-hover:text-[#1F5EFF] transition-colors leading-tight">
                    {p.title}
                  </h2>
                  {p.excerpt && <p className="mt-4 text-white/60 text-sm leading-relaxed">{p.excerpt}</p>}
                  <div className="mt-6 inline-flex items-center gap-2 text-sm text-white/60 group-hover:text-white">
                    Read article <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-1"/>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
